import React from 'react';
import styled from 'styled-components';

const NotFoundStyle = styled.div`
  position: absolute;
  top: 50%; 
  right: 50%;
  transform: translate(50%,-50%);
`
const NotFound: React.FC = () => {
  return <NotFoundStyle className="notfound">404 PAGE</NotFoundStyle>;
};

export { NotFound };
